import React from "react";
import { DataTable } from "./DataTable";
import { Button } from "antd";
import { YhBox } from "@/components/YhBox";
import { useSosModel } from "../sosModel";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/AppResourceAuthEnum";

export const DataBox = () => {
    const { exportSos } = useSosModel();

    const action = <>
        <YhAuth resCode={ResourceAuthEnum.B_A_EX}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                onClick={() => exportSos()}
            >导出</Button>
        </YhAuth>

    </>;

    return (
        <YhBox title="" action={action}>
            <DataTable />
        </YhBox>
    )
}